/******************************************************************************

Copyright (c) 2016-2018, Highsoft

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

import {
  cr,
  ap,
  setStyle,
  on,
  getElementSize,
  getElementPosition,
} from '../../core/highed.dom';
import {
  ready,
  merge,
  isFn,
  isStr,
  hexToRgba,
  setPixel,
  rgbaObjToHex,
  rgbObjToHex,
  hsvToRgb,
  rgbToHsv,
} from '../../core/highcharts-editor';
import Movable from './../highed.mover';

/*
  TODO: 
    Fix alignment of slider indicator
      Check how it's done in draw()

    Hook up slider so it properly affects the chart
    Make sure it changes color etc when rest of picker does

*/

export default class ColorSlider {
  constructor(
    xPos,
    yPos,
    width,
    height,
    calcColor,
    sliderPos,
    parent,
    callback
  ) {
    this.xPos = xPos;
    this.yPos = yPos;
    this.width = width;
    this.height = height;
    this.callback = callback;
    this.parent = parent;
    this.calcColor = calcColor;
    this.sliderPos = sliderPos;

    this.container = cr('div', 'highed-color-slider');
    this.sliderBody = cr('canvas', 'highed-color-slider-body');
    this.indicator = cr('div', 'highed-color-slider-indicator');
    this.sliderBody.width = width;
    this.sliderBody.height = height;

    this.mover = Movable(this.indicator, 'X', true, this.slider);

    this.ctx = this.sliderBody.getContext('2d');

    this.build();
    this.setup();
  }

  build() {
    ap(this.container, this.sliderBody, this.indicator);
    setStyle(this.indicator, {
      left: this.sliderPos * this.width - 10 + 'px',
    });
  }

  draw() {
    let imageData = this.ctx.getImageData(0, 0, this.width, this.height);

    for (let x = 0; x < this.width; x++) {
      let color = this.calcColor(x / this.width);
      for (let y = 0; y < this.height; y++) {
        setPixel(imageData, x, y, color);
      }
    }

    this.ctx.putImageData(imageData, 0, 0);

    let alphaSliderPos = this.sliderPos * this.width - 10;
    setStyle(this.indicator, {
      left: alphaSliderPos + 'px',
    });
  }

  /*set sliderPos(sliderPos) {
    this.sliderPos = sliderPos;
  }

  get sliderPos() {
    return this.sliderPos;
  }*/

  setup() {
    on(this.sliderBody, 'click', (event) => {
      const { left } = this.sliderBody.getBoundingClientRect();
      let x = event.clientX - left;
      this.sliderPos = x / this.width;
      let color = this.calcColor(this.sliderPos);

      setStyle(this.indicator, {
        left: x + 'px',
      });

      this.callback(color);
    });
    this.mover.on('Moving', (x) => {
      this.sliderPos = x / this.width;
      let color = this.calcColor(this.sliderPos);

      this.callback(color);
    });
  }
}
